import React, { useState } from 'react'
import { ProfileSelect } from '../../components/ProfileSelect'
import { TargetedProducts } from '../../components/products/TargetedProducts'
import { EditableField } from '../../packages/blueprint-components/src/EditableField'
import { NumericInput } from '@blueprintjs/core'
import { FormInput } from '../../components/auth/common'
import { SmartBidSettingBadge } from '../../components/SmartBidSettingsBadge'
import { TabbedCards } from '../../components/ui/TabbedCards'
import { Chart } from '../../components/chart/chart'
import { StateBadge } from '../../components/badge/StateBadge'
import { KeywordMatchTypes, TargetingType } from '../../config'
import { Filter } from '../../components/Filter'
import { Filters } from '../../config'
import { TargetingTypeBadge } from '../../components/badge/TargetingTypeBadge'
import { KeywordMatchTypeBadge } from '../../components/badge/KeywordMatchTypeBadge'
import { TargetingTypeSmall } from '../../components/badge/TargetingTypeSmall'
import { MatchTypeSmall } from '../../components/badge/MatchTypeSmall'
import { axiosGet } from '../../util/api'
import { InputField } from '../../components/ui/InputField'
import { Breadcrumbs } from '../../components/breadcrumbs/Breadcrumbs'
import Slider from 'rc-slider'
import { Button } from '../../components/ui/button'

import { State } from '../../constants'

const InputTests = () => {
    const [value, setValue] = useState(0)

    return (
        <div>
            <InputField type="integer" maximum={100} />

            <NumericInput
                // className={className}
                // disabled={disabled}
                buttonPosition={null}
                selectAllOnFocus
                value={value}
                onValueChange={(num, e) => {
                    setValue(e)
                }}
            />
        </div>
    )
}

export const Sink = ({}) => {
    const [editable1, setEditable1] = useState('')
    const [editable2, setEditable2] = useState(100)
    const [loading, setLoading] = useState(false)
    const [breadcrumbsWidth, setBreadcrumbsWidth] = useState(300)

    const data = [
        [
            1619136000, 1619222400, 1619308800, 1619395200, 1619481600, 1619568000, 1619654400,
            1619740800, 1619827200, 1619913600, 1620000000, 1620086400, 1620172800, 1620259200,
            1620345600, 1620432000, 1620518400, 1620604800, 1620691200, 1620777600, 1620864000,
            1620950400, 1621036800,
        ],
        [
            237.24, 295.25, 324.24, 297.02, 286.74, 259.65, 251.65, 252.14, 294.05, 310.58, 269.09,
            277.07, 243.5, 196.64, 171.73, 171.07, 168.01, 223.59, 163.01, 161.72, 151.89, 152.73,
            3.93,
        ],
        [
            1619136000, 1619222400, 1619308800, 1619395200, 1619481600, 1619568000, 1619654400,
            1619740800, 1619827200, 1619913600, 1620000000, 1620086400, 1620172800, 1620259200,
            1620345600, 1620432000, 1620518400, 1620604800, 1620691200, 1620777600, 1620864000,
            1620950400, 1621036800,
        ],
        [
            469.75, 765.61, 954.58, 833.58, 591.69, 765.6, 677.65, 708.66, 895.64, 880.54, 870.54,
            942.59, 715.79, 614.69, 540.79, 490.74, 657.67, 413.01, 467.76, 50.72, 50.75, 50.81,
            0.0,
        ],
    ]

    const setEditable = (value) => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
            setEditable2(value)
        }, 500)
    }

    const DefaultDateOperators = [
        DateOperator.InTheLast,
        DateOperator.LessThan,
        DateOperator.LessThanOrEqualTo,
        DateOperator.GreaterThan,
        DateOperator.GreaterThanOrEqualTo,
        DateOperator.EqualTo,
        DateOperator.Between,
    ]

    const Date = {
        // prefix: window.marketplace.currency_symbol,
        operators: DefaultDateOperators,
        key: 'start_date',
        name: 'Date',
        type: 'date',
    }

    const filters = [
        Filters.State,
        Filters.TargetingType,
        Filters.DailyBudget,
        Filters.SmartBid,
        Filters.TargetACOS,
        Date,
    ]

    return (
        <div className="p-4">
            <h3>Breadcrumbs Component</h3>
            <div className="bg-gray-200">
                <Breadcrumbs source="Test this long ass name but make it even longer bla bla lorem ipsum dolorem" />
            </div>
            <div className="w-2/3">
                <Slider
                    labelStepSize={200}
                    stepSize={50}
                    max={1200}
                    min={100}
                    value={breadcrumbsWidth}
                    onChange={(v) => setBreadcrumbsWidth(v)}
                />
            </div>

            <InputTests />

            <Button
                onClick={() => {
                    axiosGet('api/v2/info', null, true)
                        .then((r) => {
                            console.log('r is', r)
                        })
                        .catch((err) => {
                            console.log('err:', err)
                        })
                }}
                text="Test"
            />

            <h4>Targeting Type Badge</h4>
            <div className="flex">
                <div className="mr-8">
                    <b>Manual</b>
                    <div className="flex">
                        <TargetingTypeBadge targeting_type={TargetingType.Manual} />
                        <div className="ml-3">Original - Manual</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall targeting_type={TargetingType.Manual} />
                        <div className="ml-3">New - Manual no state</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Manual}
                            state={State.Enabled}
                        />
                        <div className="ml-3">New - Manual Enabled</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Manual}
                            state={State.Paused}
                        />
                        <div className="ml-3">New - Manual Paused</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Manual}
                            state={State.Archived}
                        />
                        <div className="ml-3">New - Manual Archived</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Manual}
                            state={State.Enabled}
                            parent_ad_group_status={State.Paused}
                        />
                        <div className="ml-3">New - Manual Split</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Manual}
                            state={State.Enabled}
                            parent_ad_group_status={State.Archived}
                        />
                        <div className="ml-3">New - Manual Split</div>
                    </div>
                </div>

                <div>
                    <b>Auto</b>
                    <div className="flex">
                        <TargetingTypeBadge targeting_type={TargetingType.Auto} />
                        <div className="ml-3">Original - Auto</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall targeting_type={TargetingType.Auto} />
                        <div className="ml-3">New - Auto no state</div>
                    </div>

                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Auto}
                            state={State.Enabled}
                        />
                        <div className="ml-3">New - Auto Enabled</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Auto}
                            state={State.Paused}
                        />
                        <div className="ml-3">New - Auto Paused</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Auto}
                            state={State.Archived}
                        />
                        <div className="ml-3">New - Auto Archived</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Auto}
                            state={State.Enabled}
                            parent_ad_group_status={State.Paused}
                        />
                        <div className="ml-3">New - Auto Split</div>
                    </div>
                    <div className="flex">
                        <TargetingTypeSmall
                            targeting_type={TargetingType.Auto}
                            state={State.Enabled}
                            parent_ad_group_status={State.Archived}
                        />
                        <div className="ml-3">New - Auto Split</div>
                    </div>
                </div>
            </div>

            <h4 className="mt-20">Keyword Match Type Badge</h4>
            <div className="flex">
                <div className="mr-8">
                    <b>Broad</b>
                    <div className="flex">
                        <KeywordMatchTypeBadge match_type={KeywordMatchTypes.Broad} />
                        <div className="ml-3">Original - Broad</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Broad} />
                        <div className="ml-3">New - Broad no state</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Broad} state={State.Enabled} />
                        <div className="ml-3">New - Broad Enabled</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Broad} state={State.Paused} />
                        <div className="ml-3">New - Broad Paused</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Broad}
                            state={State.Archived}
                        />
                        <div className="ml-3">New - Broad Archived</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Broad}
                            state={State.Enabled}
                            parent_ad_group_status={State.Paused}
                        />
                        <div className="ml-3">New - Broad Split</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Broad}
                            state={State.Enabled}
                            parent_ad_group_status={State.Archived}
                        />
                        <div className="ml-3">New - Broad Split</div>
                    </div>
                </div>

                <div className="mr-8">
                    <b>Phrase</b>
                    <div className="flex">
                        <KeywordMatchTypeBadge match_type={KeywordMatchTypes.Phrase} />
                        <div className="ml-3">Original - Phrase</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Phrase} />
                        <div className="ml-3">New - Phrase no state</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Phrase}
                            state={State.Enabled}
                        />
                        <div className="ml-3">New - Phrase Enabled</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Phrase} state={State.Paused} />
                        <div className="ml-3">New - Phrase Paused</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Phrase}
                            state={State.Archived}
                        />
                        <div className="ml-3">New - Phrase Archived</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Phrase}
                            state={State.Enabled}
                            parent_ad_group_status={State.Paused}
                        />
                        <div className="ml-3">New - Phrase Split</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Phrase}
                            state={State.Enabled}
                            parent_ad_group_status={State.Archived}
                        />
                        <div className="ml-3">New - Phrase Split</div>
                    </div>
                </div>

                <div>
                    <b>Exact</b>
                    <div className="flex">
                        <KeywordMatchTypeBadge match_type={KeywordMatchTypes.Exact} />
                        <div className="ml-3">Original - Exact</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Exact} />
                        <div className="ml-3">New - Exact no state</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Exact} state={State.Enabled} />
                        <div className="ml-3">New - Exact Enabled</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall matchType={KeywordMatchTypes.Exact} state={State.Paused} />
                        <div className="ml-3">New - Exact Paused</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Exact}
                            state={State.Archived}
                        />
                        <div className="ml-3">New - Exact Archived</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Exact}
                            state={State.Enabled}
                            parent_ad_group_status={State.Paused}
                        />
                        <div className="ml-3">New - Exact Split</div>
                    </div>
                    <div className="flex">
                        <MatchTypeSmall
                            matchType={KeywordMatchTypes.Exact}
                            state={State.Enabled}
                            parent_ad_group_status={State.Archived}
                        />
                        <div className="ml-3">New - Exact Split</div>
                    </div>
                </div>
            </div>

            <h4>State Badge</h4>
            <div>
                <label>Enabled</label>
                <StateBadge state={State.Enabled} />
            </div>
            <div>
                <label>Paused</label>
                <StateBadge state={State.Paused} />
            </div>
            <div>
                <label>Archived</label>
                <StateBadge state={State.Archived} />
            </div>
            <div>
                <label>Parent Campaign Archived</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Enabled}
                    parent_campaign_status={State.Archived}
                />
            </div>
            <div>
                <label>Parent Ad Group Archived</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Archived}
                    parent_campaign_status={State.Enabled}
                />
            </div>
            <div>
                <label>Parent Campaign & Ad Group Archived</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Archived}
                    parent_campaign_status={State.Archived}
                />
            </div>
            <div>
                <label>Parent Campaign Paused</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Enabled}
                    parent_campaign_status={State.Paused}
                />
            </div>
            <div>
                <label>Parent Ad Group Paused</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Paused}
                    parent_campaign_status={State.Enabled}
                />
            </div>
            <div>
                <label>Parent Campaign & Ad Group Paused</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Paused}
                    parent_campaign_status={State.Paused}
                />
            </div>
            <div>
                <label>All Paused</label>
                <StateBadge
                    state={State.Paused}
                    parent_ad_group_status={State.Paused}
                    parent_campaign_status={State.Paused}
                />
            </div>
            <div>
                <label>All Archived</label>
                <StateBadge
                    state={State.Paused}
                    parent_ad_group_status={State.Paused}
                    parent_campaign_status={State.Paused}
                />
            </div>
            <div>
                <label>Mixed</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Paused}
                    parent_campaign_status={State.Archived}
                />
            </div>
            <div>
                <label>Mixed - other way</label>
                <StateBadge
                    state={State.Enabled}
                    parent_ad_group_status={State.Archived}
                    parent_campaign_status={State.Paused}
                />
            </div>

            <h4 className="mt-4">Charts</h4>
            <Chart title="Sales" data={data} />

            <hr />

            <TabbedCards tabs={['Ad Groups', 'Search Terms', 'Campaign Negative Keywords']}>
                <span>ad groups</span>
                <span>search terms</span>
                <span>cnks</span>
            </TabbedCards>

            <ProfileSelect />

            <div className="my-5 flex flex-col">
                <label>
                    Single <pre>TargetedProducts</pre>
                </label>
                <TargetedProducts
                    item={{
                        product_ads: [{ asin: 'BOOKBOOK12' }],
                    }}
                />
            </div>

            <div className="my-5 flex flex-col">
                <label>
                    Multiple <pre>TargetedProducts</pre>
                </label>
                <TargetedProducts
                    item={{
                        product_ads: [
                            { asin: 'BOOKBOOK12' },
                            { asin: 'BOOKBOOK13' },
                            { asin: 'BOOKBOOK14' },
                        ],
                    }}
                />
            </div>

            <div className="my-5 d-flex flex-col align-items-center">
                <label>Editable field, empty</label>
                <EditableField value={editable1} onChange={setEditable1} />
            </div>

            <div className="my-5 d-flex flex-col align-items-center">
                <label>Editable field, preloaded with loading</label>
                <EditableField value={editable2} loading={loading} onChange={setEditable} />
            </div>

            <div className="my-5 d-flex flex-col align-items-center">
                <label>Form input, money</label>
                <FormInput type="money" value={editable1} onChange={setEditable1} />
                <code className="bg-gray-200 border rounded p-1">
                    {'<FormInput type="money" value={value} onChange={setValue} />'}
                </code>
            </div>

            <div className="my-5 d-flex flex-col align-items-center">
                <label>Form input, percentage, decimalPlaces = 2</label>
                <FormInput
                    type="percentage"
                    decimalPlaces={2}
                    value={editable1}
                    onChange={setEditable1}
                />
                <code className="bg-gray-200 border rounded p-1">
                    {
                        '<FormInput type="percentage" decimalPlaces={2} value={value} onChange={setValue} />'
                    }
                </code>
            </div>

            <div className="my-5 d-flex flex-col align-items-center">
                <label>Form input, percentage, decimalPlaces = 0</label>
                <FormInput
                    type="percentage"
                    decimalPlaces={0}
                    value={editable1}
                    onChange={setEditable1}
                />
                <code className="bg-gray-200 border rounded p-1">
                    {
                        '<FormInput type="percentage" decimalPlaces={0} value={value} onChange={setValue} />'
                    }
                </code>
            </div>

            <div className="my-3">Just plain old normal text.</div>

            <h1 className="my-3">An H1 header tag</h1>

            <div className="my-3">
                <Button intent="primary" text="Save" className="m-3" />
                <Button intent="primary" large text="Large" className="m-3" />
            </div>
            <div className="my-3">
                <Button className="m-3" intent="light" text="Save" />
                <Button className="m-3" intent="light" large text="Large" />
            </div>

            <div className="my-3">
                <SmartBidSettingBadge active={false} className="pr-6" />
                <SmartBidSettingBadge active={true} />
            </div>

            <div className="my-3">
                <h2>Filter Component</h2>
                <Filter
                    className="mr-2"
                    filters={filters}
                    // defaultFilter={defaultFilter}
                    customFilters={[]}
                    saveFilter={() => console.log('save filter')}
                    deleteCustomFilter={() => console.log('delete filter')}
                    editCustomFilter={() => console.log('edit filter')}
                    onChange={(filters) => {
                        console.log('ON CHANGE', filters)
                    }}
                    enableSave={false}
                />
            </div>

            <div className="mb-10" style={{ height: '100px' }} />
        </div>
    )
}
